import { ListeningOn } from './types';

export function mapIcons(listenOn: ListeningOn[], locale: string) {
    if (Array.isArray(listenOn)) {
        const translationsForLocale = translations[normalizeLocale(locale)];
        // Check if listenOn is a Contentful document string
        const listenOnParsed = listenOn.map((value) => {
            // If Contentful document string then parse JSON and get the headline property
            if (value.startsWith('{')) {
                const parsed = JSON.parse(value);
                return parsed?.headline;
            }
            // Else we use the legacy content
            else {
                return value;
            }
        });
        return {
            inside: {
                isActive: listenOnParsed.indexOf('Satellite') !== -1,
                label: translationsForLocale?.SATELLITE,
            },
            outside: {
                isActive: listenOnParsed.indexOf('Streaming') !== -1,
                label: translationsForLocale?.STREAMING,
            },
            pandora: {
                isActive:
                    listenOnParsed.indexOf('Pandora') !== -1 ||
                    listenOnParsed.indexOf('Custom Stations') !== -1,
                label: translationsForLocale?.PANDORA,
            },
            perks: {
                isActive: listenOnParsed.indexOf('Perks') !== -1,
                label: translationsForLocale?.PERKS,
            },
        };
    } else {
        return null;
    }
}

function normalizeLocale(locale: string): 'en-US' | 'en-CA' | 'fr-CA' {
    switch (locale.replace('_', '-')) {
        case 'en-CA':
            return 'en-CA';
        case 'fr-CA':
            return 'fr-CA';
        case 'en-US':
        default:
            return 'en-US';
    }
}

const translations = {
    'en-US': {
        SATELLITE: 'Inside<br/>the Car',
        STREAMING: 'On the<br/>SiriusXM app',
        PANDORA: 'Custom<br/>Stations',
        PERKS: 'VIP<br/>Perks',
    },
    'en-CA': {
        SATELLITE: 'Inside<br/>the Car',
        STREAMING: 'On the<br/>SiriusXM app',
        PANDORA: 'Custom<br/>Stations',
        PERKS: 'VIP<br/>Perks',
    },
    'fr-CA': {
        SATELLITE: 'Dans<br/>la voiture',
        STREAMING: 'Sur l’appli<br/>SiriusXM',
        PANDORA: 'Stations<br/>personnalisées',
        PERKS: 'Avantages<br/>VIP',
    },
};
